import React from 'react'
import { useSelector } from 'react-redux';
import { Privileges } from '../../util/PrivilegeConstants';
import {isUser } from '../../util/UserRoles';
import { isReservationInThePast } from '../../util/CalendarUtil';

const EditorFooterTemplate = ({ args, privileges }) => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const playerBlockedFromDelete = isUser(userInfo)
        && isReservationInThePast(args?.StartTime);
    const showDelete = args?.Id
        && !playerBlockedFromDelete
        && (!args.Subject || (args.Subject === 'IN PROGRESS' && isUser(userInfo)) || (!isUser(userInfo) && privileges?.RESERVATION?.includes(Privileges.DELETE)));
    return (
        <div id="event-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div id="left-button">
                {showDelete &&
                    <button id="Delete" className="e-control e-btn e-danger" data-ripple="true" >
                        Delete
                    </button>
                }
            </div>
            <div id="right-button">
                {(!args.Subject || (args.Subject === 'IN PROGRESS' && privileges?.RESERVATION?.includes(Privileges.MODIFY))) &&
                    <button id="reservation_save_button" className="e-control e-btn e-primary" data-ripple="true" >
                        {args.Id ? 'Save' : 'Add To Cart'}
                    </button>
                }
                <button id="Cancel" className="e-control e-btn e-secondary" data-ripple="true">
                    Cancel
                </button>
            </div>
        </div>
    );
}

export default EditorFooterTemplate
